const currentPage = () => {
  if (typeof window === 'undefined') return

  const path = window.location.pathname

  return {
    isHomePage: path === '/',
    isExamShowcasePage: path === '/exames' || path === '/exames/',
    isVaccineShowcasePage: path === '/vacinas' || path === '/vacinas/',
    isExamDetailPage: /^\/exames\/[^\/]+\/?$/.test(path),
    isVaccineDetailPage: /^\/vacinas\/[^\/]+\/?$/.test(path),
    isBlogHomePage: path === '/noticias' || path === '/noticias/',
    isBlogArticlePage: /^\/saude\/[^\/]+\/?$/.test(path),
    isUnitShowcasePage: path === '/unidades' || path === '/unidades/',
    isUnitDetailPage: /^\/unidades\/[^\/]+\/?$/.test(path),
    isInsurancePage: path === '/convenios' || path === '/convenios/',
  }
}

const pushToDataLayerOnPageLoad = () => {
  if (typeof window === 'undefined') return

  window.dataLayer = window.dataLayer || []

  const {
    isExamShowcasePage,
    isVaccineShowcasePage,
    isExamDetailPage,
    isVaccineDetailPage,
  } = currentPage()

  let has_product_added = false
  let products

  const persistedRoot = sessionStorage.getItem('persist:root')

  if (persistedRoot) {
    const parsedState = JSON.parse(persistedRoot)

    const productsJson =
      isVaccineShowcasePage || isVaccineDetailPage
        ? parsedState.cartItemsVaccine
        : parsedState.cartItemsExam

    products = JSON.parse(productsJson).map(product => ({
      id: product.id,
      name: product.name,
      category: product.category,
      quantity: 1,
    }))

    has_product_added = products.length > 0
  }

  if (isExamShowcasePage || isVaccineShowcasePage) {
    const eventObj = {
      event: 'funnel_step',
      funnel: {
        name: isVaccineShowcasePage ? 'Agendamento de Vacinas' : 'Agendamento de Exames',
        current_step: isVaccineShowcasePage ? 'Busca de vacinas' : 'Busca de exames',
      },
    }

    if (products) {
      eventObj.has_product_added = has_product_added
      eventObj.products = products
    }

    window.dataLayer.push(eventObj)
  }

  if (isExamDetailPage || isVaccineDetailPage) {
    const eventObj = {
      event: 'funnel_step',
      funnel: {
        name: isVaccineDetailPage ? 'Agendamento de Vacinas' : 'Agendamento de Exames',
        current_step: isVaccineDetailPage ? 'Página de Vacina' : 'Página de Exame',
      },
    }

    if (products) {
      eventObj.has_product_added = has_product_added
      eventObj.products = products
    }

    window.dataLayer.push(eventObj)
  }
}

const pushToDataLayer = ({ event, name, currentStep, products, has_product_added, _clear }) => {
  if (typeof window === 'undefined') return

  window.dataLayer = window.dataLayer || []

  const {
    isExamShowcasePage,
    isVaccineShowcasePage,
    isExamDetailPage,
    isVaccineDetailPage,
  } = currentPage()

  const funnelName =
    isVaccineShowcasePage || isVaccineDetailPage
      ? 'Agendamento de Vacinas'
      : 'Agendamento de Exames'

  let funnelCurrentStep

  if (isExamShowcasePage || isVaccineShowcasePage) {
    funnelCurrentStep = isVaccineShowcasePage ? 'Busca de vacinas' : 'Busca de exames'
  }

  if (isExamDetailPage || isVaccineDetailPage) {
    funnelCurrentStep = isVaccineDetailPage ? 'Página de Vacina' : 'Página de Exame'
  }

  window.dataLayer.push({
    event,
    funnel: {
      name: name || funnelName,
      current_step: currentStep || funnelCurrentStep,
    },
    has_product_added: has_product_added,
    ...(_clear === true && { _clear: true }),
    products: products.map(product => ({
      id: product.id,
      name: product.name,
      category: product.category,
      quantity: 1,
    })),
  })
}

module.exports = { currentPage, pushToDataLayerOnPageLoad, pushToDataLayer }
